import axios from "axios";
export default defineNuxtPlugin(NuxtApp => {
    return {
        provide: {
            axios: axios
        }
    }
});
